import {FormSectionType} from '../../../../blocks/FormBlock'
import birthDateField from '../../EditionRegistration/fields/birthDateField'
import {copy} from '../../../../../util/fieldscopy'
import emailField from '../../EditionRegistration/fields/emailField'
import firstNameField from '../../EditionRegistration/fields/firstNameField'
import genderField from '../../EditionRegistration/fields/genderField'
import lastNameField from '../../EditionRegistration/fields/lastNameField'
import mobileField from '../../EditionRegistration/fields/mobileField'
import phoneField from '../fields/phoneField'

const sectionId: number = 1
const personalInfoSection: FormSectionType = {
	id: sectionId,
	parent_id: 0,
	channel: 'section',
	label: copy?.personal || 'Persoonlijke gegevens',
	fields: [
		{...firstNameField, id: 1, parent_id: sectionId},
		{...lastNameField, id: 2, parent_id: sectionId},
		{...emailField, id: 3, parent_id: sectionId, mod: 'half'},
		{...phoneField, id: 4, parent_id: sectionId},
		{...mobileField, id: 5, parent_id: sectionId},
		{...birthDateField, id: 6, parent_id: sectionId},
		{...genderField, id: 7, parent_id: sectionId}
	]
}

export default personalInfoSection
